/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientPhone/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import Checkbox from 'DesignSystem/Checkbox/index'
import ChoiceRadial from 'DesignSystem/ChoiceRadial/index'
import MaskedInput from 'DesignSystem/MaskedInput/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import Status from './Status/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function PatientPhone({
  children,
  viewPath = "/App/Form/Data/ProvideData/PatientPhone",
  onChange,
  onSubmit,
  value,
  onClickType,
  valueType,
  valueNotifications,
  onClickNotifications,
  onClickConsentNotification,
  valueConsent
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="PatientPhone.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-ZQjmOk': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="PatientPhone.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 marginBottom={0}
 marginTop={4}
 text="What is the patient's phone number?"
/>
</div>
<MaskedInput
  viewPath={`${viewPath}/MaskedInput`}
 autoFocus={true}
 mask="phone"
 onChange={onChange}
 onSubmit={onSubmit}
 placeholder="(000) 000-0000"
 type="text"
 initialValue={value}
/>
<div
  data-testid="PatientPhone.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<ChoiceRadial
  viewPath={`${viewPath}/ChoiceRadial`}
 id="CELL"
 onClick={onClickType}
 selected={valueType}
 text="Cell"
/>
<ChoiceRadial
  viewPath={`${viewPath}/ChoiceRadial`}
 id="LANDLINE"
 marginLeft={8}
 onClick={onClickType}
 selected={valueType}
 text="Landline"
/>
</div>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 isSelected={valueNotifications}
 marginTop={16}
 onClick={onClickNotifications}
 text="Yes, send me reminders"
/>
<div
  data-testid="PatientPhone.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 marginTop={16}
 onClick={onClickConsentNotification}
 isSelected={valueConsent}
 text=""
/>
<div
  data-testid="PatientPhone.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="PatientPhone.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
By providing your phone number, you agree to receive text messages from this practice.
</span>
<span
  data-testid="PatientPhone.Text:1"
  data-view-path={viewPath}
 className={`views-text ${styles.Text1}`}
>
Message and data rates may apply. Message frequency varies. Reply STOP to opt-out.
</span>
</div>
</div>
<Status
  viewPath={`${viewPath}/Status`}
 onSubmit={onSubmit}
/>
</div>
{children}
</React.Fragment>)
}